"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup_1 = require("@hookform/resolvers/yup");
const react_hook_form_1 = require("react-hook-form");
const yup = __importStar(require("yup"));
const react_1 = require("react");
const Utils_1 = require("../../../../utils/Utils");
const hook_1 = require("../../../../redux/hook");
const user_api_1 = require("../../../../utils/api/user/user.api");
const User_slice_1 = require("../../../../redux/slice/User.slice");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
function UseUpdateProfil() {
    const [code, setCode] = (0, react_1.useState)("SN");
    const [phone, setPhone] = (0, react_1.useState)();
    const validationSchema = yup.object().shape({
        fullname: yup.string().required("Le Nom complet est obligatoire"),
        address: yup.string(),
        phone: (0, Utils_1.validatePhone)(yup, code).required("Téléphone est obligatoire"),
        email: yup.string().email().required("Email est obligatoire"),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const [address, setAddress] = (0, react_1.useState)("");
    const dispatch = (0, hook_1.useAppDispatch)();
    const [addOrUpdateAuthUser, { isLoading, isSuccess, error, isError, data },] = (0, user_api_1.useUpdateAuthUserMutation)();
    const [addOrUpdateAuthAvatar, { isLoading: isLoadAvatar, isSuccess: isSuccessAvatar, error: errorAvatar, isError: isErrorAvatar, data: dataAvatar, },] = (0, user_api_1.useUpdateAuthAvatarMutation)();
    const handleChangeAvatar = (e) => {
        let files = e.target.files ? e.target.files[0] : null;
        if (!files)
            return;
        let fd = new FormData();
        fd.append("fullname", user === null || user === void 0 ? void 0 : user.fullname);
        fd.append("email", user === null || user === void 0 ? void 0 : user.email);
        fd.append("address", user === null || user === void 0 ? void 0 : user.address);
        fd.append("avatar", files);
        addOrUpdateAuthAvatar({
            id: user === null || user === void 0 ? void 0 : user.user_id,
            data: fd,
        });
    };
    const handleChangePhone = (item, country) => {
        var _a;
        setCode(((_a = country === null || country === void 0 ? void 0 : country.countryCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || "SN");
        setPhone(item);
        if (parseInt(item) !== parseInt(country === null || country === void 0 ? void 0 : country.dialCode)) {
            setValue(`phone`, "+" + item);
        }
        else {
            setValue(`phone`, "");
        }
    };
    const onChangeAddress = (val) => {
        setAddress(val === null || val === void 0 ? void 0 : val.rue);
        setValue("address", val === null || val === void 0 ? void 0 : val.rue);
    };
    // Logique pour la mise à jour de l'utilisateur
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f;
        if (isSuccess) {
            if ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.user_id) {
                if ((user === null || user === void 0 ? void 0 : user.user_id) === ((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.user_id)) {
                    dispatch((0, User_slice_1.onSetUser)(data === null || data === void 0 ? void 0 : data.data));
                }
            }
            react_hot_toast_1.default.success(data === null || data === void 0 ? void 0 : data.message, {
                duration: 3000,
                position: "top-center",
            });
        }
        const err = error;
        if (isError) {
            if ((_d = (_c = err === null || err === void 0 ? void 0 : err.data) === null || _c === void 0 ? void 0 : _c.email) === null || _d === void 0 ? void 0 : _d.includes("l'utilisateur avec cet email existe déjà.")) {
                react_hot_toast_1.default.error("Un utilisateur avec cet email exite déjà!", {
                    duration: 3000,
                    position: "top-center",
                });
            }
            else {
                react_hot_toast_1.default.error(((_e = err === null || err === void 0 ? void 0 : err.data) === null || _e === void 0 ? void 0 : _e.message)
                    ? (_f = err === null || err === void 0 ? void 0 : err.data) === null || _f === void 0 ? void 0 : _f.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`, {
                    duration: 5000,
                    position: "top-center",
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);
    // Logique pour la mise à jour de l'avatar
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        if (isSuccessAvatar) {
            if ((_a = dataAvatar === null || dataAvatar === void 0 ? void 0 : dataAvatar.data) === null || _a === void 0 ? void 0 : _a.user_id) {
                if ((user === null || user === void 0 ? void 0 : user.user_id) === ((_b = dataAvatar === null || dataAvatar === void 0 ? void 0 : dataAvatar.data) === null || _b === void 0 ? void 0 : _b.user_id)) {
                    dispatch((0, User_slice_1.onSetUser)(dataAvatar === null || dataAvatar === void 0 ? void 0 : dataAvatar.data));
                }
            }
            react_hot_toast_1.default.success(dataAvatar === null || dataAvatar === void 0 ? void 0 : dataAvatar.message, {
                duration: 3000,
                position: "top-center",
            });
        }
        const err = errorAvatar;
        if (isErrorAvatar) {
            react_hot_toast_1.default.error(((_c = err === null || err === void 0 ? void 0 : err.data) === null || _c === void 0 ? void 0 : _c.message)
                ? (_d = err === null || err === void 0 ? void 0 : err.data) === null || _d === void 0 ? void 0 : _d.message
                : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`, {
                duration: 5000,
                position: "top-center",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadAvatar]);
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    (0, react_1.useEffect)(() => {
        if (user === null || user === void 0 ? void 0 : user.user_id) {
            let fields = [
                "fullname",
                "phone",
                "email",
                "address",
            ];
            for (let field of fields) {
                register(field);
                setValue(field, user[field]);
            }
            if (user === null || user === void 0 ? void 0 : user.phone) {
                setPhone(user === null || user === void 0 ? void 0 : user.phone);
            }
            setAddress(user === null || user === void 0 ? void 0 : user.address);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        !user && (data["status"] = "admin");
        addOrUpdateAuthUser({
            id: user === null || user === void 0 ? void 0 : user.user_id,
            data: data,
        });
    });
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        handleChangeAvatar,
        phone,
        handleChangePhone,
        address,
        onChangeAddress,
    };
}
exports.default = UseUpdateProfil;
